import {GetValues_ForSchema} from "js-vextensions";
import {AddSchema} from "mobx-graphlink";

export enum Phase {
	notStarted = "notStarted",
	initialDelay = "initialDelay",
	tech = "tech",
	drifting = "drifting",
	dreaming = "dreaming",
	solving = "solving", // todo: probably rename this someday (eg. to "return", "deild", or "silent")
	delving = "delving",
	//logging = "logging",
}
AddSchema("Phase", {oneOf: GetValues_ForSchema(Phase)});